export class StaticPageService {
  public getStaticPageContentSync() {
    return {
      loading: {
        loadingUsers: {
          titleNormalText: "Loading",
          titleBoldText: "Notes",
          description: "Please wait while we load notes.",
        },
        usersEmpty: {
          titleNormalText: "No Notes",
          titleBoldText: "Found",
          description: "No presentation feature notes available.",
        },
      },
    };
  }
}
